export function removeSpaces(value: string) {
  return value.replace(/\s/g, "");
}
